import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Menu } from 'antd';
import styled from 'styled-components';
import { checkAccess } from '../core/utils'

const HeaderMenuComponent = ({ pages, $invert }) => {
  const { currentRoute } = useSelector((store) => store.nav);
  const { accessComponentsForUser } = useSelector((store) => store.services);
  const navigate = useNavigate();

  const handleChangeCurrentRoute = (e) => {
    navigate(e.key);
  }

  const accessPages = pages?.map(page => 
    checkAccess(accessComponentsForUser, page.key) ? page : null
  ).filter(Boolean);
  
  return <StyledMenu mode="horizontal" selectedKeys={[currentRoute]} items={accessPages} onClick={handleChangeCurrentRoute} $invert={$invert}/>;
};

export default HeaderMenuComponent;

const StyledMenu = styled(Menu)`
  width: 80%;
  height: 100%;
  background-color: ${(p) => p.$invert ? '#2f2f2f' : '#fff'} !important;
  & a {
    color: ${(p) => p.$invert ? '#fff' : '#000'} !important;
  }
`;
